import { GameCard } from '@optools/components/game-card';
import { PipelineStatusBadge } from '@optools/components/pipelines/pipeline-status-badge';
import { Button } from '@optools/components/ui/button';
import { Card } from '@optools/components/ui/card';
import { LoggerScheduleGame } from '@optools/services/operator-gateway/logger/types';
import { Link } from '@tanstack/react-router';
import { Tv } from 'lucide-react';

export interface LoggerGameCardProps {
  date: string;
  game: LoggerScheduleGame;
}

export function LoggerGameCard({ date, game }: LoggerGameCardProps) {
  return (
    <GameCard
      actionButton={
        <Button asChild size="sm" variant="outline">
          <Link from="/" params={{ gamePk: game.gamePk }} search={{ date }} to="/logger/$gamePk">
            <Tv />
            Log Game
          </Link>
        </Button>
      }
      data-testid={`logger-game-card-${game.gamePk}`}
      game={game}>
      {game.pipelines?.length ? (
        <div className="mt-8">
          <h3 className="mb-2 font-bold">Pipelines</h3>
          <Card className="w-max p-2">
            <ul className="flex flex-col gap-2">
              {game.pipelines?.length > 0 &&
                game.pipelines?.map((pipeline) => (
                  <li
                    key={pipeline.id}
                    aria-label={`${pipeline.feedType} - ${pipeline.programSource}`}
                    className="flex items-center gap-2 not-last:border-b-1 not-last:pb-2">
                    <p className="text-xs">
                      {pipeline.feedType} - {pipeline.programSource}
                    </p>
                    <PipelineStatusBadge status={pipeline.status} />
                  </li>
                ))}
            </ul>
          </Card>
        </div>
      ) : null}
    </GameCard>
  );
}
